export default "__VITE_ASSET__DfC6tNO3__"